import script from "./workHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./workHistory.vue?vue&type=script&lang=ts&setup=true"

import "./workHistory.vue?vue&type=style&index=0&id=37000e35&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4390a2cfce3e8645dfb3e8bd3a167747/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37000e35"]])

export default __exports__